export class DistributorFilter {
  IdBrand: number = 0;
  IdRegion: number = 0;
  IdSector: number = 0;
  IdVnPlate: number = 0;
  IdPvGroup: number = 0;
  IdDistributor: number = 0;
  Year: number = new Date().getFullYear();
  ZoneManager: number = 0;
  IdStatus: number = 0;
}

export class IdTitle {
  id: number;
  title: string;
}


export class DistributorParams {
  Region: string[] = [];
  Sector: string[] = [];
  VnPlate: string[] = [];
  PvGroup: string[] = [];
  SectionPv: string[] = [];
  Distributor: string[] = [];
  IdBrand: number = 0;
}
